module.exports = __webpack_public_path__ + "static/m-e09f1f174c442f556e7211fb52caecf1.png";